import { array } from 'fp-ts';
import styled from 'styled-components';
import { ItemAlignment, Stack } from '@optimus-web/core';
import BreadcrumbItem, { ActiveBreadcrumb, Breadcrumb, ClickableBreadcrumb, isActive } from './BreadcrumbItem';

export type Breadcrumbs = [...ClickableBreadcrumb[], ActiveBreadcrumb];

const BreadcrumbList = ({
    breadcrumbs,
    alignment = 'end',
}: {
    breadcrumbs: Breadcrumbs;
    alignment?: ItemAlignment;
}) => {
    const renderBreadcrumbs = array.map((breadcrumb: Breadcrumb) => {
        if (isActive(breadcrumb)) {
            return <BreadcrumbItem key="active-breadcrumb" active={breadcrumb.active} text={breadcrumb.text} />;
        }

        return <BreadcrumbItem key={breadcrumb.url} url={breadcrumb.url} text={breadcrumb.text} />;
    });

    return (
        <BreadcrumbsStack alignment={alignment} itemAlignment="center">
            {renderBreadcrumbs(breadcrumbs)}
        </BreadcrumbsStack>
    );
};

const BreadcrumbsStack = styled(Stack)`
    line-height: initial;
    overflow: hidden;
    white-space: nowrap;
`;

export default BreadcrumbList;
